<template>
	<div class="w-100">
		<div class="card-wrapper position-relative"
			:class="type_class">
			<div class="w-100 pt-4 pl-4">
				<img class="d-inline-block align-middle mr-2" src="../../assets/img/hotel/logo_white.png" height="30" />
				<p class="mb-0 d-inline-block align-middle body-1-4 text-white">Kubu Tropis</p>
			</div>
			<div class="position-absolute" style="top:30px;right:30px;">
				<p class="mb-0 body-2-2 text-white font-italic text-capitalize">{{type}} Member</p>
			</div>
			<div class="position-absolute" style="bottom:30px;left:30px;">
				<p class="mb-0 body-1-4 text-white text-26 text-uppercase line-height-1">Jessica Jung</p>
				<p class="mb-0 d-inline-block align-middle body-1-2 text-white">ID. 1810</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			type: {
				type: String,
				default: 'gold'
			}
		},
		computed:{
			type_class(){
				return this.type+'-card'
			}
		}
	}
</script>
<style scoped>
	.platinum-card{
		background: #1c4d5e;
		background: linear-gradient(100deg,#1c4d5e 0%, #b8c5f9 500%);
		background: -webkit-linear-gradient(100deg,#1c4d5e 0%, #b8c5f9 500%);
		background: -moz-linear-gradient(100deg,#1c4d5e 0%, #b8c5f9 500%);
		box-shadow: -6px 17px 20px -10px rgba(9, 62, 81, 0.53);
		-webkit-box-shadow: -6px 17px 20px -10px rgba(9, 62, 81, 0.53);
		-moz-box-shadow: -6px 17px 20px -10px rgba(9, 62, 81, 0.53);
	}
	.gold-card{
		background: #f7971e;
		background: linear-gradient(100deg,#f7971e 0%, #ffd200 500%);
		background: -webkit-linear-gradient(100deg,#f7971e 0%, #ffd200 500%);
		background: -moz-linear-gradient(100deg,#f7971e 0%, #ffd200 500%);
		box-shadow: -6px 17px 20px -10px rgba(219, 136, 31, 0.64);
		-webkit-box-shadow: -6px 17px 20px -10px rgba(219, 136, 31, 0.64);
		-moz-box-shadow: -6px 17px 20px -10px rgba(219, 136, 31, 0.64);
	}
	.card-wrapper{
		width: 100%;
		height: 240px;
		border-radius: 20px;
	}
	.card-wrapper::after {
	  content: "";
	  background: url("../../assets/img/hotel/bg_ga.png");
	  opacity: 0.1;
	  top: 0;
	  left: 0;
	  bottom: 0;
	  right: 0;
	  position: absolute;
	  z-index: 1;
		background-size: 35%;
		background-repeat: no-repeat;  
		background-position: 93% 80%;
	}

	@media screen and (max-width: 655px) {
		.card-wrapper{
			height: 200px!important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/MemberCard.vue